export default __webpack_public_path__ + "static/media/store.2e9fc7b5.png";